import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { EVENT_MARKERS_LIMIT } from '@/consts/visualisations';
import { PromiseAtom } from '@/types/atom';
import { InfoBar } from '../feedback/InfoBar';

const EventCountInfoBarBase = ({ eventCountAtom }: { eventCountAtom: PromiseAtom<number> }) => {
  const { t } = useTranslation('dataVis');
  const eventCount = useAtomValue(eventCountAtom);

  /* hide info bar if has been filtered down below limit */
  if (eventCount <= EVENT_MARKERS_LIMIT || !eventCount) return null;

  const mainText = t('eventCountInfoBar', { limit: EVENT_MARKERS_LIMIT, total: eventCount });

  return (
    <div className="px-4">
      <InfoBar testId="event-count-info-bar" mainText={mainText} />{' '}
    </div>
  );
};

export const EventCountInfoBar = ({ eventCountAtom }: { eventCountAtom: PromiseAtom<number> }) => (
  <Suspense fallback={<div className="-mt-4" data-testid="event-count-loading" />}>
    <EventCountInfoBarBase eventCountAtom={eventCountAtom} />
  </Suspense>
);
